import { render, staticRenderFns } from "./LogosOnly.vue?vue&type=template&id=a15959b8&scoped=true&"
import script from "./LogosOnly.vue?vue&type=script&lang=ts&"
export * from "./LogosOnly.vue?vue&type=script&lang=ts&"
import style0 from "./LogosOnly.vue?vue&type=style&index=0&id=a15959b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15959b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
